class Search {
    constructor() {
        this.isInitialized = false;
    }

    init() {
        this.element = document.getElementById("live-search-form");
        if (this.element) {
            this.searchInput = document.getElementById("live-search");
            this.searchList = document.getElementById("live-search-list");
            this.currentPointer = -1;
            this.searchTimeout = null;
            this.isInitialized = true;
            this.searchInput.onkeydown = this.typing;
            this.searchInput.onblur = this.onblur;
            this.isInitialized = true;
            this.isOpen = false;
        }
    }

    onLiveSearchToggleChange() {
        if (this.isOpen) {
            this.close();
        } else {
            this.isOpen = true;
            $(this.element).clearQueue().fadeIn(100);
            this.setFocus();
        }
    }

    close() {
        if (this.isOpen && window.innerWidth <= 1024 && typeof this.element === "object") {
            $(this.element).clearQueue().fadeOut(100);
            this.isOpen = false;
            this.searchInput.value = "";
            this.reset();
        }
    }

    setFocus() {
        this.searchInput.focus();
    }

    typing(e) {
        const items = app.search.searchList.querySelectorAll('div.search-item');
        switch (e.keyCode) {
            case 13:
                e.preventDefault();
                if (items.length) {
                    items[Math.max(app.search.currentPointer, 0)].click();
                    app.search.close();
                }
                break;
            case 38:
                e.preventDefault();
                if (items.length > 1) {
                    app.search.currentPointer--;
                    app.search.addActive(items);
                }
                break;
            case 40:
                e.preventDefault();
                if (items.length > 1) {
                    app.search.currentPointer++;
                    app.search.addActive(items);
                }
                break;

            default:
                app.search.query();
                break;
        }
    }

    query() {
        this.reset();
        setTimeout(() => {
            if (this.searchInput.value.toString().length > 1) {
                this.searchList.classList.add("loading");
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    if (this.searchInput.value.toString().length) {
                        app.ajax.get('/services/search/live-search?query=' + this.searchInput.value.toLowerCase(), {}, this.handleResult.bind(this));
                    }
                }, 750);
            } else {
                this.reset();
                this.searchList.classList.remove("loading");
            }
        }, 2);
    }

    handleResult(result) {
        this.reset();
        this.searchList.classList.remove("loading");
        if (result.length) {
            for (let prop in result) {
                const item = document.createElement('div');
                const catItem = document.createElement('div');
                catItem.classList.add('search-item-category');
                catItem.innerHTML = result[prop].category;
                item.classList.add('search-item');
                item.setAttribute('data-url', result[prop].url);
                item.innerHTML = result[prop].item.replace(new RegExp(this.searchInput.value, "ig"), "<b>$&</b>");
                item.onclick = () => {
                    app.search.pick(result[prop].url)
                };
                item.appendChild(catItem);
                this.searchList.appendChild(item);
            }
        } else {
            this.searchList.innerHTML = "<div class='h-3 font-weight-bolder text-center'>?</div>";
        }
    }

    onClick(e) {
        const clickedItem = (e.target.dataset.url === undefined) ? e.target.parentNode : e.target;
        if (clickedItem.dataset.url !== undefined) {
            if (clickedItem.dataset.url.indexOf("/play") > 10) {
                app.launcher.openGame(clickedItem.dataset.url);
            } else {
                app.ajax.inject(clickedItem.dataset.url, '#page');
            }
            app.search.reset();
            app.search.searchInput.value = "";
        }
    }

    pick(url) {
        if (url.indexOf("/play") > 10) {
            app.launcher.openGame(url);
        } else {
            app.ajax.inject(url, '#page');
        }
        app.search.reset();
        app.search.searchInput.value = "";
    }

    addActive(items) {
        if (!items || items.length === 0) {
            return false;
        }
        this.removeActive(items);
        if (this.currentPointer >= items.length) {
            this.currentPointer = 0;
        }
        if (this.currentPointer < 0) {
            this.currentPointer = (items.length - 1);
        }
        items[this.currentPointer].classList.add('autocomplete-active');
        const value = this.searchInput.value;
        this.searchInput.value = "";
        setTimeout(() => {
            this.searchInput.value = value;
        }, 1);
    }

    removeActive(items) {
        for (let i = 0; i < items.length; i++) {
            items[i].classList.remove('autocomplete-active');
        }
    }

    select(item) {
        this.searchInput.value = item;
    }

    clearSearchList() {
        this.searchList.innerHTML = '';
    }

    reset() {
        this.clearSearchList();
        this.currentPointer = -1;
    }

    onblur() {
        setTimeout(() => {
            app.search.close();
        }, 200);
    }
}